import PropTypes from 'prop-types';

import LandingSection from '@spotahome/ui-library/src/tenant/components/LandingSection/LandingSection';

import City from './City';

import './Cities.scss';

const Cities = ({ countryId, cities = [] }) => {
  return (
    <LandingSection
      containerClassName="cities-section"
      observableSection="all-cities"
    >
      {cities.map(city => (
        <LandingSection key={city.id} observableSection={`city-${city.id}`} containerClassName="cities-section__city">
          <City city={{ ...city, countryId }} />
        </LandingSection>
      ))}
    </LandingSection>
  );
};
Cities.propTypes = {
  countryId: PropTypes.string.isRequired,
  cities: PropTypes.array.isRequired
};

export default Cities;
